import useProjects from '@activities/ProjectActivity/hooks/useProjects';
import Card from '@components/Card';
import Column from '@components/Column';
import Header from '@components/Header';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useToast from '@hooks/ui/useToast';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useCookies } from 'react-cookie';

const ProjectActivity: ActivityComponentType = () => {
  const [cookies, setCookies] = useCookies(['projectId']);
  const defaultProjectId = cookies.projectId;
  const toast = useToast();
  const projects = useProjects();
  const handleSave = (projectId: string) => {
    setCookies('projectId', projectId, { path: '/', maxAge: 60 * 60 * 24 * 365 * 20 });
    toast.success('프로젝트 ID가 저장되었습니다.');
    window.location.href = '/';
  };
  return (
        <AppScreen>
            <Column fullWidth>
                <Header title='테스트 프로젝트 설정' />
                <Container
                    spacing={24}
                    fullWidth >
                    <Text fontWeight='bold'> 프로젝트 선택 </Text>
                    <Column fullWidth spacing={8}>
                        {projects?.map((project) => (
                            <Card key={project.id}
                                  onClick={() => handleSave(project.id)} >
                                <Card.Body>
                                    <Row fullWidth justify='space-between'>
                                        <Text size='lg' fontWeight='medium'>
                                            {project.name} ({project.id})
                                        </Text>
                                        {defaultProjectId === project.id && (
                                            <Text color={colors.primary} fontWeight='bold'>
                                                선택됨
                                            </Text>
                                        )}
                                    </Row>
                                </Card.Body>
                            </Card>
                        ))}
                    </Column>
                </Container>
            </Column>
        </AppScreen>
  );
};

const Container = styled(Column)`
    padding: 20px;
`;

export default ProjectActivity;
